module.exports = __webpack_public_path__ + "mf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mf.svg
// module id = 939
// module chunks = 0